import { firebaseAuth } from "../../firebase";
import { REHYDRATE } from "redux-persist/constants";
import {
  SMS_VERIFICATION_SEND_REQUEST,
  SMS_VERIFICATION_SEND_SUCCESS,
  SMS_VERIFICATION_SEND_FAILURE,
  VALIDATE_VERIFICATION_CODE_REQUEST,
  VALIDATE_VERIFICATION_CODE_SUCCESS,
  VALIDATE_VERIFICATION_CODE_FAILURE,
  AUTH_DELEGATION_REQUEST,
  AUTH_DELEGATION_SUCCESS,
  AUTH_DELEGATION_FAILURE,
  SIGN_OUT,
  INTRO_HIDE,
  INTRO_SHOW,
  USER_LOCATION_RECEIVED,
  TRACK,
  USER_HAVE_MOBILE_APP,
  CLEAR_ALL,
  AUTH_SAVE_USER_DATA
} from "./actions";
import { NO_USER_PROFILE } from "../issues/actions";
import errorsList from "../../fixtures/errorsList";
import mixpanel from "mixpanel-browser";
mixpanel.init("aa91546448165b8b99f9d66bc15f5ced");

const initialState = {
  isVerificationFetch: false,
  verificationSent: false,
  verificationSendError: false,
  verificationSendErrorMessage: false,
  isValidationFetch: false,
  validationError: false,
  validationErrorMessage: false,
  authenticated: false,
  userId: false,
  id_token: false,
  access_token: false,
  phone_number: false,
  firebase: {
    id_token: false
  },
  showIntro: false,
  location: false,
  haveMobileApp: true,
  user: false,
  shouldLogOut: false
};

function track(title, props) {
  if (!title) {
    return;
  }

  if (props) {
    mixpanel.track(title, props);
  } else {
    mixpanel.track(title);
  }
}

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case REHYDRATE: {
      const savedData = action.payload.auth || initialState;

      if (savedData.userId) {
        // console.log(savedData);
        mixpanel.identify(savedData.userId);
        // mixpanel.people.set({ "id": savedData.userId });
        track("Entered web app");
      }

      return {
        ...state,
        ...savedData,
        isVerificationFetch: false,
        verificationSent: false,
        verificationSendError: false,
        verificationSendErrorMessage: false,
        isValidationFetch: false,
        validationError: false
      };
    }
    case NO_USER_PROFILE: {
      return {
        ...state,
        shouldLogOut: true
      }
    }
    case AUTH_SAVE_USER_DATA: {

      return {
        ...state,
        user: action.payload
      }
    }
    case TRACK: {
      const { title, props } = action.payload;
      track(title, props);
      return state;
    }
    case SMS_VERIFICATION_SEND_REQUEST: {
      return {
        ...state,
        isVerificationFetch: true,
        verificationSendError: false,
        verificationSendErrorMessage: false
      };
    }
    case SMS_VERIFICATION_SEND_SUCCESS: {
      return {
        ...state,
        userId: `sms|${action.payload.Id}`,
        isVerificationFetch: false,
        verificationSent: true,
        phone_number: action.payload.phoneNumber
      };
    }
    case SMS_VERIFICATION_SEND_FAILURE: {
      return {
        ...state,
        isVerificationFetch: false,
        verificationSendError: true,
        verificationSendErrorMessage:
          errorsList[action.payload.code] ||
          "Sorry, something went wrong. Please try again later"
      };
    }
    case VALIDATE_VERIFICATION_CODE_REQUEST: {
      return {
        ...state,
        isValidationFetch: true
      };
    }
    case VALIDATE_VERIFICATION_CODE_SUCCESS: {
      localStorage.setItem(
        "auth0",
        JSON.stringify({
          userId: state.userId,
          access_token: action.payload.access_token,
          id_token: action.payload.id_token
        })
      );
      return {
        ...state,
        isValidationFetch: false,
        id_token: action.payload.id_token,
        access_token: action.payload.access_token,
        authenticated: true
      };
    }
    case VALIDATE_VERIFICATION_CODE_FAILURE: {
      return {
        ...state,
        isValidationFetch: false,
        validationError: true,
        validationErrorMessage:
          action.payload.error_description ||
          "Sorry, something went wrong. Please try again later"
      };
    }
    case AUTH_DELEGATION_REQUEST: {
      return { ...state };
    }
    case AUTH_DELEGATION_SUCCESS: {
      return {
        ...state,
        firebase: {
          id_token: action.payload.idToken
        }
      };
    }
    case AUTH_DELEGATION_FAILURE: {
      return { ...state };
    }
    case SIGN_OUT: {
      return {
        ...initialState,
        showIntro: false
      };
    }
    case INTRO_SHOW: {
      return {
        ...state,
        showIntro: true
      };
    }
    case INTRO_HIDE: {
      return {
        ...state,
        showIntro: false
      };
    }
    case USER_LOCATION_RECEIVED: {
      return {
        ...state,
        location: action.payload
      };
    }
    case USER_HAVE_MOBILE_APP: {
      return {
        ...state,
        haveMobileApp: action.payload
      };
    }
      case CLEAR_ALL: {
          return {
              ...state,
              isVerificationFetch: false,
              verificationSent: false,
              verificationSendError: false,
              verificationSendErrorMessage: false,
              isValidationFetch: false,
              validationError: false,
              validationErrorMessage: false,
              authenticated: false,
              userId: false,
              id_token: false,
              access_token: false,
              phone_number: false,
              firebase: {
                  id_token: false
              },
              showIntro: false,
              location: false,
          };
      }

    default: {
      return { ...state };
    }
  }
}
